import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-btn-copy',
  templateUrl: './btn-copy.component.html',
  styleUrls: ['./btn-copy.component.scss']
})
export class BtnCopyComponent {
  @Input() copy = true;
  @Input() copyExternal = false;
  @Input() data: any;
  @Input() label: any;
  @ViewChild('iconCopy') iconCopy: any
  @Output() copyData: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  copyToClipboard() {
    this.iconCopy.nativeElement?.classList.add("icon-copy-success");
    if(this.copyExternal) {
      this.copyData.emit(this.data);
    } else {
      navigator.clipboard.writeText(this.data);
    }
    setTimeout(() => {
      this.iconCopy.nativeElement?.classList.remove("icon-copy-success")
    }, 1500);
  }
}
